import { render, staticRenderFns } from "./nav-section.vue?vue&type=template&id=a3970902&scoped=true"
import script from "./nav-section.vue?vue&type=script&lang=ts"
export * from "./nav-section.vue?vue&type=script&lang=ts"
import style0 from "./nav-section.vue?vue&type=style&index=0&id=a3970902&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3970902",
  null
  
)

export default component.exports